import React, { useState, useEffect, ChangeEvent } from "react";
import { Select, Input, Form } from "antd";
import "./DefaultInput.css";

const { Option } = Select;

interface PhoneNumberInputProps {
	allowedPrefixes?: string[];
	initialPhoneNumber?: string;
	onPhoneNumberChange: (phoneNumber: string) => void;
	placeholder?: string;
	label: string;
	className?: string;
}

const DefaultPhoneInput: React.FC<PhoneNumberInputProps> = ({
	allowedPrefixes = ["383", "355", "389"],
	initialPhoneNumber = "",
	onPhoneNumberChange,
	placeholder,
	label,
	className,
}) => {
	const initialPrefix =
		allowedPrefixes.find(
			(prefix) => initialPhoneNumber?.startsWith(prefix)
		) || allowedPrefixes[0];

	const initialNumber = initialPhoneNumber?.replace(initialPrefix, "");

	const [selectedPrefix, setSelectedPrefix] = useState(initialPrefix);
	const [phoneNumber, setPhoneNumber] = useState(initialNumber);

	useEffect(() => {
		setSelectedPrefix(initialPrefix);
		setPhoneNumber(initialNumber);
	}, [initialNumber, initialPhoneNumber, initialPrefix]);

	const handlePrefixChange = (value: string) => {
		setSelectedPrefix(value);
		onPhoneNumberChange(value + phoneNumber);
	};

	const handlePhoneNumberChange = (event: ChangeEvent<HTMLInputElement>) => {
		const newPhoneNumber = event.target.value;
		setPhoneNumber(newPhoneNumber);
		onPhoneNumberChange(selectedPrefix + newPhoneNumber);
	};

	return (
		<div className="flex flex-col gap-1 ">
			<label className="w-42 -mb-1">{label}</label>
			<div className="flex justify-center items-center">
				<Select
					value={selectedPrefix}
					onChange={handlePrefixChange}
					style={{ width: 70, height: 43 }}
					className={`default-select ${className}`}
				>
					{allowedPrefixes.map((prefix) => (
						<Option key={prefix} value={prefix}>
							{prefix}
						</Option>
					))}
				</Select>
				<Input
					type="text"
					value={phoneNumber}
					onChange={handlePhoneNumberChange}
					className={`default-input ${className}`}
					placeholder={
						placeholder ? placeholder : "Enter phone number:"
					}
				/>
			</div>
		</div>
	);
};

export default DefaultPhoneInput;
